import { UserContextProvider } from "./Contexts/UserContext";
import { Menu } from "./Layout/Menu";
import { Footer } from "./Layout/Footer";
import { RecipesGrid } from "./Routes/RecipesGrid/RecipesGrid";
import { RecipeView } from "./Routes/RecipeView/RecipeView";
import { CreateRecipe } from "./Routes/CreateRecipe/CreateRecipe";
import { EditRecipe } from "./Routes/EditRecipe/EditRecipe";
import { CloneRecipe } from "./Routes/CloneRecipe/CloneRecipe";
import { RecipeHistory } from "./Routes/RecipeHistory/RecipeHistory";
import { RecipeHistoryView } from "./Routes/RecipeHistory/RecipeHistoryView";
import { RecipeCompare } from "./Routes/RecipeHistory/RecipeCompare";
import { Login } from "./Routes/Login/Login";
import { Logout } from "./Routes/Logout/Logout";
import { UserAdmin } from "./Routes/UserAdmin/UserAdmin";
import { EditUser } from "./Routes/EditUser/EditUser";
import { VolumeToMassConversionAdmin } from "./Routes/VolumeToMassConversionAdmin/VolumeToMassConversionAdmin";
import { EditVolumeToMassConversion } from "./Routes/EditVolumeToMassConversion/EditVolumeToMassConversion";
import { UnitEquivalentAdmin } from "./Routes/UnitEquivalentAdmin/UnitEquivalentAdmin";
import { EditUnitEquivalent } from "./Routes/EditUnitEquivalent/EditUnitEquivalent";
import { UnitAppropriationAdmin } from "./Routes/UnitAppropriationAdmin/UnitAppropriationAdmin";
import { EditUnitAppropriation } from "./Routes/EditUnitAppropriation/EditUnitAppropriation";
import { MetricConversionAdmin } from "./Routes/MetricConversionAdmin/MetricConversionAdmin";
import { EditMetricConversion } from "./Routes/EditMetricConversion/EditMetricConversion";
import { TagAdmin } from "./Routes/TagAdmin/TagAdmin";
import { RouteNotFound } from "./Shared/RouteNotFound";
import { Redirect } from "react-router";
import { GoogleOAuthProvider } from "@react-oauth/google";
import "typeface-roboto";
import React, { useState, useEffect } from "react";
import {
	BrowserRouter,
	Switch,
	Route
} from "react-router-dom";
import CssBaseline from "@material-ui/core/CssBaseline";
import "./Content/site.scss";

export default function App(props) {
	const [config, setConfig] = useState(props.config);

	useEffect(() => {
		setConfig(props.config);
	}, [config]); // eslint-disable-line react-hooks/exhaustive-deps

	const moreProps = { config: config };

	return (
		<GoogleOAuthProvider clientId={config.googleClientId}>
			<BrowserRouter>
				<CssBaseline />
				<UserContextProvider config={config}>
					<Menu config={config} />
					<main id="main-content">
						<Switch>
							<Route exact path="/" render={() => (<Redirect to="/recipes" />)} />
							<Route exact path="/recipes" render={(props) => <RecipesGrid {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/create" render={(props) => <CreateRecipe {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId" render={(props) => <RecipeView {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId/edit" render={(props) => <EditRecipe {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId/clone" render={(props) => <CloneRecipe {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId/history" render={(props) => <RecipeHistory {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId/history/compare/:id1/:id2" render={(props) => <RecipeCompare {...{ ...props, ...moreProps }} />} />
							<Route exact path="/recipes/:recipeId/history/:recipeHistoryId" render={(props) => <RecipeHistoryView {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/users" render={(props) => <UserAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/users/create" render={(props) => <EditUser {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/users/:appUserId/edit" render={(props) => <EditUser {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/volume-to-mass-conversions" render={(props) => <VolumeToMassConversionAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/volume-to-mass-conversions/create" render={(props) => <EditVolumeToMassConversion {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/volume-to-mass-conversions/:volumeToMassConversionId/edit" render={(props) => <EditVolumeToMassConversion {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-equivalents" render={(props) => <UnitEquivalentAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-equivalents/create" render={(props) => <EditUnitEquivalent {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-equivalents/:unitEquivalentId/edit" render={(props) => <EditUnitEquivalent {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-appropriations" render={(props) => <UnitAppropriationAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-appropriations/create" render={(props) => <EditUnitAppropriation {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/unit-appropriations/:unitAppropriationId/edit" render={(props) => <EditUnitAppropriation {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/metric-conversions" render={(props) => <MetricConversionAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/metric-conversions/create" render={(props) => <EditMetricConversion {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/metric-conversions/:metricConversionId/edit" render={(props) => <EditMetricConversion {...{ ...props, ...moreProps }} />} />
							<Route exact path="/admin/tags" render={(props) => <TagAdmin {...{ ...props, ...moreProps }} />} />
							<Route exact path="/login" render={(props) => <Login {...{ ...props, ...moreProps }} />} />
							<Route exact path="/logout" render={(props) => <Logout {...{ ...props, ...moreProps }} />} />
							<Route component={RouteNotFound} />
						</Switch>
					</main>
					<Footer />
				</UserContextProvider>
			</BrowserRouter >
		</GoogleOAuthProvider>
	);
}
